<template>
  <main class="view">
    <DebuggingHelper v-if="showDebuggingControls" />
    <MainLayoutSlider>
      <slot v-if="boardStore.boardLayout === 'fullscreen'" name="fullscreen" />
      <div v-else class="full-view">
        <HomeHeader />
        <LiveFeed />
        <MainLayoutSlider>
          <slot v-if="boardStore.boardLayout === 'framed'" name="framed" />
          <div v-else class="semi-full-view">
            <div class="square-view">
              <MainLayoutSlider>
                <slot
                  v-if="boardStore.boardLayout === 'square'"
                  name="square"
                />
              </MainLayoutSlider>
            </div>
            <SliderStatus />
            <JournalSection />
            <SectionsDivider />
            <NextUpSection />
          </div>
        </MainLayoutSlider>
      </div>
    </MainLayoutSlider>
  </main>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import DebuggingHelper from '@/components/DebuggingHelper.vue'
import HomeHeader from '@/components/HomeHeader.vue'
import JournalSection from '@/components/JournalSection.vue'
import LiveFeed from '@/components/LiveFeed.vue'
import MainLayoutSlider from '@/components/MainLayoutSlider.vue'
import NextUpSection from '@/components/NextUpSection.vue'
import SectionsDivider from '@/components/SectionsDivider.vue'
import SliderStatus from '@/components/SliderStatus.vue'
import { useBoardStore } from '@/stores/useBoardStore'
import shouldShowHelpButtons from '@/utils/shouldShowHelpButtons'

const boardStore = useBoardStore()
const route = useRoute()

const showDebuggingControls = computed(
  () => shouldShowHelpButtons || Boolean(route.query.show_controls)
)
</script>
<style lang="scss" scoped>
.square-view {
  width: 100%;
  height: vh(1957px);
}

.semi-full-view {
  position: absolute;
  width: 100%;
  height: vh(2824px);
}

.full-view {
  position: absolute;
  width: vw();
  height: vh();
}

.view {
  width: vw();
  height: vh();
  overflow-x: hidden;
  background-color: $background;
}
</style>
